// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UV45","inner":"Footer_inner__lvtrN","nextIcon":"Footer_nextIcon__2Ojit","innerLeft":"Footer_innerLeft__2k3Fl"};